import { inject } from '@angular/core'
import type { CanActivateFn } from '@angular/router'
import { Router } from '@angular/router'
import { AuthService } from './auth.service'
import { landingFor } from './landing'

/**
 * A direct hit on '' — the same landing rule the login form navigates through
 * (`landingFor`, shared so the two can't drift): no-access / select-account /
 * admin / FR-050 white-label campaign list (AC-7.1) / FR-018 D11 first-login
 * account page / dashboard. AC-6 (FR-018): this only fires on the '' route, so an
 * explicit nav to /portal/profile is never swallowed.
 */
export const rootRedirectGuard: CanActivateFn = async () => {
  const auth = inject(AuthService)
  const router = inject(Router)
  // FR-050 FIX-COV2 N2: the anonymous-safe session probe first, /me only when signed
  // in — a signed-out hard load of '/' makes no failing request (no 401 in the
  // console) and lands on /login as before. FR-051 U7 (AC-5.6): signed out, the
  // login of the brand shown — the host's own /login on an agency host.
  const user = await auth.probeSession()
  void router.navigateByUrl(user ? landingFor(user) : auth.loginPath())
  return false
}
